/** Exempt Private Company (M32016) 문서 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { EpcFieldType } from './epcFields';

export interface EpcDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => EpcFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;
  entityCd: Ref<string>;
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;
}

export const EPC_DOC_CTX: InjectionKey<EpcDocContext> = Symbol('epcDocCtx');
